export default "__VITE_ASSET__DvaLRN8K__"